import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import * as authApi from '@@client/auth/api';
import { tokenFresh, getAuthSession, saveAuthSession, removeAuthSession } from '@@client/lib/auth';
import { logout } from '@@client/account/logout/actions'; // will try to get a token, if fails will return a response that can be returned from most requests. if success,
// will run f(token) and return the result. this is a super common use-case, so cleaner to just put the code here.

export var tokenRequest = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(tokenCache, f) {
    var errorMsg,
        token,
        _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            errorMsg = _args.length > 2 && _args[2] !== undefined ? _args[2] : 'You are not allowed to perform this action. You may need to log in first.';
            _context.prev = 1;
            _context.next = 4;
            return tokenCache.get();

          case 4:
            token = _context.sent;
            _context.next = 10;
            break;

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](1);
            return _context.abrupt("return", {
              success: false,
              errors: [errorMsg]
            });

          case 10:
            return _context.abrupt("return", f(token));

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 7]]);
  }));

  return function tokenRequest(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}(); // sort of mutex. make sure only one request is happening at a time

var OnlyOneAction = function OnlyOneAction() {
  var active = false;
  var activeP;
  return function (f) {
    return function () {
      if (active) return activeP;
      active = true;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      activeP = f.apply(null, args).then(function (x) {
        active = false;
        return x;
      })["catch"](function (err) {
        active = false;
        throw err;
      });
      return activeP;
    };
  };
}; // ctx is used to send the token back to the user if we retrieve one on their behalf


export default function TokenCache(store) {
  var ctx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var tokenCushion = 60; // 60 seconds

  var onlyOneAction = OnlyOneAction(); // need to call actions on store in this function because if they're run on .then or .catch outside this function, they
  // could happen on each call to this function (remember it's mutexed, so only one action can be performed at once). when
  // called inside, will only be called once per action, not once per call.

  var refresh = onlyOneAction(function (store, apiUrl, refreshToken) {
    return authApi.refresh(apiUrl, refreshToken).then(function (result) {
      // Don't show a notification if revoke failed because the user didn't initiate a logout action themselves, we're just doing it to be safe. If it fails and they get a message, it will be confusing.
      var logoutOptions = {
        notifyOnRevokeFailure: false
      };

      if (!result.success) {
        if (result.unauthorized) {
          store.dispatch(logout(tokenCache, _objectSpread({
            revoke: false
          }, logoutOptions)));
        } else {
          store.dispatch(logout(tokenCache, logoutOptions));
        }

        throw Error('Could not refresh');
      } else {
        try {
          saveAuth({
            token: result.payload.token
          });
          return result.payload.token;
        } catch (err) {
          store.dispatch(logout(tokenCache, logoutOptions));
          throw err;
        }
      }
    });
  }); // need to call actions on store in this function because if they're run on .then or .catch outside this function, they
  // could happen on each call to this function (remember it's mutexed, so only one action can be performed at once). when
  // called inside, will only be called once per action, not once per call.

  var visitor = onlyOneAction(function (store, apiUrl) {
    return authApi.visitor(apiUrl).then(function (result) {
      if (!result.success) {
        store.dispatch(logout(tokenCache));
        throw Error('Could not get visitor token.');
      }

      saveAuth({
        token: result.payload.token
      });
      return result.payload.token;
    })["catch"](function (err) {
      store.dispatch(logout(tokenCache));
      throw err;
    });
  });

  var getAuth = function getAuth() {
    return getAuthSession(ctx);
  };

  var saveAuth = function saveAuth(info) {
    var state = store.getState();
    saveAuthSession(state.config.auth.claimsNamespace, info, ctx);
  };

  var removeAuth = function removeAuth() {
    removeAuthSession(ctx);
  };

  var tokenCache = {
    get: function get() {
      var authSession = getAuth();
      var state = store.getState(); // already have a current auth token

      if (authSession.token && tokenFresh(authSession.tokenExpiresAt, tokenCushion)) {
        return Promise.resolve(authSession.token);
      } // don't have a refresh token or have an expired refresh token, try to get a visitor token
      else if (!authSession.refresh || !tokenFresh(authSession.refreshExpiresAt, tokenCushion)) {
          return visitor(store, state.config.auth.apiUrl);
        } // try to refresh
        else {
            return refresh(store, state.config.auth.apiUrl, authSession.refresh);
          }
    },
    // adding these here since this object is already global and has access to ctx (both of which will be needed to save and get auth directly from cookies every time needed)
    getAuth: getAuth,
    saveAuth: saveAuth,
    removeAuth: removeAuth
  };
  return tokenCache;
}